import { Button } from '#/components/ui/button';
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from '#/components/ui/hover-card';
import { CopyToClipboardButton } from '#/components/v2/copy-to-clipboard';
import useEthereumBeaconscanBlockExplorer from '#/data/useEthereumBeaconscanBlockExplorer';
import { ellipsizeString } from '#/lib/ellipsize-string';
import { HoverCardProps } from '@radix-ui/react-hover-card';
import { Translation } from 'intl-lib';
import { ExternalLink } from 'lucide-react';
import Link from 'next/link';

interface Props extends HoverCardProps {
  validatorIndex?: string | number | null;
  publicKey?: string | null; // fallback
}

export function ValidatorIndex({ validatorIndex, publicKey, ...props }: Props) {
  const blockExplorer = useEthereumBeaconscanBlockExplorer();
  return validatorIndex != null || publicKey != null ? (
    <HoverCard openDelay={0} {...props}>
      <HoverCardTrigger className="underline decoration-dashed decoration-gray-300 underline-offset-4">
        {validatorIndex != null
          ? `#${validatorIndex}`
          : ellipsizeString(publicKey, 4)}
      </HoverCardTrigger>
      <HoverCardContent className="w-auto">
        <div className="flex flex-col gap-2">
          <div className="flex flex-col gap-2">
            <h4 className="text-sm font-semibold">
              Validator{validatorIndex != null && <> #{validatorIndex}</>}
            </h4>
            <div className="w-full text-sm max-w-xs break-words">
              {publicKey}
            </div>
          </div>
          <div className="flex items-center gap-2">
            <CopyToClipboardButton text={publicKey} variant="outline" size="sm">
              <Translation path="EthereumStaking.ValidatorHoverCard.CopyPublicKeyButtonLabel" />
            </CopyToClipboardButton>
            <Button variant="outline" size="sm" asChild>
              <Link
                href={`${blockExplorer?.url}/validator/${
                  validatorIndex ?? publicKey
                }`}
                target="_blank"
                rel="noreferrer"
                prefetch={false}
              >
                <ExternalLink />
                <Translation
                  path="global.noun.view_on_button_label"
                  params={blockExplorer}
                />
              </Link>
            </Button>
          </div>
        </div>
      </HoverCardContent>
    </HoverCard>
  ) : (
    '-'
  );
}
